import { SESSION_EXPIRED_ERROR } from '@/constants';
import { NavigationStepEnum, NavigationStepPathEnum } from '@/constants/navigation';
import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useGlobalLoading } from './useGlobalLoading';
import { usePagination } from './usePagination';
import { useRedirectToFirstStepIfBookingCompleted } from './useRedirectToFirstStepIfBookingCompleted';

/* TODO: Enhance the redirection logic for each step, along with the error messages.
 * For instance, if the user is on step 4 and hasn't completed the payment,
 * we should redirect them to step 3 for a smoother experience.
 */

const useInvalidSessionRedirect = () => {
  const router = useRouter();
  const { currentStep } = usePagination();
  const { session, setErrorModal, transactionId } = usePrenuvoStore(
    useShallow((state) => ({
      session: state.scan.session,
      email: state.user.email,
      setErrorModal: state.ui.methods.setErrorModal,
      transactionId: state.payment.transactionId,
    })),
  );

  const isSessionAvailable = !!session?.eventId;
  const isSessionQueryComplete = session !== undefined;
  const cannotProceedToSteps2And3 =
    isSessionQueryComplete &&
    !isSessionAvailable &&
    currentStep?.label !== NavigationStepEnum.SCAN_DETAILS;
  useRedirectToFirstStepIfBookingCompleted();

  useEffect(() => {
    if (cannotProceedToSteps2And3) {
      setErrorModal(SESSION_EXPIRED_ERROR.title, SESSION_EXPIRED_ERROR.message, {
        onClose: () => {
          router.push(NavigationStepPathEnum.SCAN_DETAILS);
        },
      });
    }
  }, [cannotProceedToSteps2And3, router, session, setErrorModal]);

  useGlobalLoading(cannotProceedToSteps2And3);

  return { label: currentStep?.label || '' };
};

export default useInvalidSessionRedirect;
